import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UsersService from '../../../services/UsersService';
import SignatureModal from '../jobDetails/WorkersTab/SignatureModal';
import MessageHiredWorkers from '../jobDetails/WorkersTab/MessageHiredWorkers';

export default class EventActionsButtons extends Component {
  static propTypes = {
    eventId: PropTypes.number.isRequired,
    hiredWorkers: PropTypes.array.isRequired,
    showApproveEventButton: PropTypes.bool.isRequired,
    signatureModalIsOpen: PropTypes.bool.isRequired,
    approveHoursEvent: PropTypes.func.isRequired,
    closeSignatureModal: PropTypes.func.isRequired,
    submitJobApprovalEmployer: PropTypes.func.isRequired,
    UIShowConfirm: PropTypes.func.isRequired,
    updateConversationMessagesCount: PropTypes.func.isRequired
  };

  render () {
    const { eventId, hiredWorkers, showApproveEventButton, approveHoursEvent, signatureModalIsOpen, closeSignatureModal,
      submitJobApprovalEmployer, UIShowConfirm, updateConversationMessagesCount } = this.props;
    const hiredWorkersExist = hiredWorkers && hiredWorkers.length > 0;
    const isAdmin = UsersService.isAdmin();
    const canMessageHiredWorkers = isAdmin && hiredWorkersExist;
    if (!canMessageHiredWorkers && !showApproveEventButton) return null;
    return (
      <div className='event-header-panel d-flex justify-content-between'>
        { canMessageHiredWorkers && (
          <MessageHiredWorkers
            eventId={eventId}
            hiredWorkers={hiredWorkers}
            updateConversationMessagesCount={updateConversationMessagesCount}
          />
        )}
        { showApproveEventButton && (
          <button
            className='button button-primary'
            onClick={approveHoursEvent}
          >
            Approve Hours
          </button>
        )}
        <SignatureModal
          isOpen={signatureModalIsOpen}
          closeModal={closeSignatureModal}
          submitJobApprovalEmployer={submitJobApprovalEmployer}
          UIShowConfirm={UIShowConfirm}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/eventView/EventActionsButtons.js